import React from 'react'

function SingleBudgetElements({mode, elements, setElements}) {


    function deleteHandler(id) {
        console.log("Delete")
        const newElements = elements.filter(el => {
            console.log(id, el.elId)
            return +el.elId !== +id
        })
        console.log(newElements)
        setElements(newElements)
    }

    function formatDescription(description) {
        console.log(description)
        if (description) {
            const descriptionArray = description.split(" ")
            console.log(descriptionArray)
        }
    }

    return (

        <ul className="list-group my-5">
            {elements?.map((element, index) => {
                return (
                    <li 
                        key={index} 
                        className="list-group-item"
                    >
                        {element.description} 
                        <span className="float-right">
                            {element.sum} 
                            {mode === "edit" && (
                                <React.Fragment>
                                    <i className="fas fa-edit text-primary pl-2"></i>
                                    <i onClick={() => deleteHandler(element.elId)} className="fas fa-trash text-danger pl-2"></i>
                                </React.Fragment>
                            )}
                        </span>
                    </li>
                )
            })}
        </ul>
    )

}
export default SingleBudgetElements